/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { loadingState } from '@app/core/ngrx';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '../types';
import { updateBillingMethod } from './actions/billing-method.actions';

export const cards = createFeatureSelector<AppState['billingCards']>('billingCards');
export const firstCard = createSelector(cards, (s) => s[0] ?? null);
export const isUpdateBillingMethodRequestInFlight = createSelector(loadingState, (loading) =>
  loading.has(updateBillingMethod.type),
);
